import { Map } from 'immutable';
import core from './core';

const INITIAL_STATE = new Map({
    list: new Map(),
    initialized: false
});
export default (env, state = INITIAL_STATE, action) => {
    switch (action.type) {
        case `${env.toUpperCase()}__SET_MANAGEMENTS`:
            return core.setManagements(state, action.managements);
        case `${env.toUpperCase()}__SET_MANAGEMENT`:
            return core.setManagement(state, action.managementId, action.management);
        case `${env.toUpperCase()}__UPDATE_MANAGEMENT`:
            return core.updateManagement(state, action.managementId, action.management);
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./environments/genericEnv/data/Managements/reducer.js